import React, { useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import AuthService from '../../services/AuthService'

export function AuthenticatedRoutes() {
  const isAuthenticated = AuthService.isAuthenticated()
  const [isOnline, setIsOnline] = useState(navigator.onLine)

  return isAuthenticated || !isOnline ? (
    <>
      <Outlet />
    </>
  ) : (
    <Navigate to="/login" replace />
  )
}
